class BackgroundSetter {
    constructor(selector = '.js-set-background') {
        this.items = $(selector);
    }

    isRetina() {
        var query = '(-webkit-min-device-pixel-ratio: 2), (min-device-pixel-ratio: 2), (min-resolution: 192dpi)';
        return matchMedia(query).matches;
    }
    
    setBackgroundImages() {
        const isMobile = $(window).width() < 992;
        // const that = this;
        let imageUrl;

        $(this.items).each(function(index, item) {
            if (isMobile && $(item).data('background-sm')) {
                imageUrl = $(item).data('background-sm');
            } else {
                imageUrl = $(item).data('background');
                // if (!that.isRetina()) {
                //     imageUrl = imageUrl.replace('@2x', '');
                // }
            }

            $(item).css('background-image', 'url(' + imageUrl + ')');
        });
    }
}

export default BackgroundSetter;


// WEBPACK FOOTER //
// ./scripts/components/BackgroundSetter.js